import { onMount } from "solid-js";
import { useNavigate } from "@solidjs/router";

export default function Register() {
    const navigate = useNavigate();
    onMount(() => {
        const search = window.location.search;
        navigate("/login" + search, { replace: true });
    });
    return null;
}
